import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import axios from 'axios';

//get Group
export const getOuGroupData = createAsyncThunk('GroupSlice/getOuGroupData', async (value) => {
  value.isDescending = value.isDescending ? value.isDescending : false;
  value.sortType = value.sortType ? value.sortType : '';
  const response = await axios.get(
    `GetADDetails/getAllGroups?FQDN=${value.fqdn}&ouName=${value.ouName}&search=${value.searchQuery}&page=${value.page}&pageSize=${value.pageSize}&isDescending=${value.isDescending}&sortType=${value.sortType}`
  );
  return response.data;
});
//get Single Group
export const getSingleGroup = createAsyncThunk('GroupSlice/getSingleGroup', async (value) => {
  const response = await axios.get(`GetADDetails/singlegroup?FQDN=${value.fqdn}&GroupName=${value.GroupName}`);
  return { status: response.status, data: response.data };
});
export const getExportGroups = createAsyncThunk('GroupSlice/getExportGroups', async (value) => {
  const response = await axios.get(
    `GetADDetails/exportgroups?FQDN=${value.fqdn}&ouName=${value.ouName}&search=${value.searchQuery}`
  );
  return response.data;
});

//get GroupDropDown
// same GetGroup Api is called to avoid the collapse of table and dropDown Data
export const getDropDownGroupData = createAsyncThunk('GroupSlice/getDropDownGroupData', async (value) => {
  const response = await axios.get(`GetADDetails/GetGroupsInExceptUser?ouName=${value.ouName}&FQDN=${value.fqdn}`);
  return response.data;
});

//cretae Group
export const createGroupData = createAsyncThunk('GroupSlice/createGroupData', async (values) => {
  try {
    const response = await axios.post(`GetADDetails/CreateGroup`, values);
    return { status: response.status, data: response.data };
  } catch (err) {
    return err;
  }
});
// Update Group
export const updateGroupProperties = createAsyncThunk('GroupSlice/updateOuDataProperties', async (values) => {
  try {
    const response = await axios.put(`GetADDetails/UpdateGroup`, values);
    return { status: response.status, data: response.data };
  } catch (err) {
    return err;
  }
});
// delete Group
export const deleteGroupData = createAsyncThunk('GroupSlice/deleteGroupData', async (value) => {
  try {
    const response = await axios.delete(`GetADDetails/DeleteGroup`, {
      params: { FQDN: value.fqdn },
      data: value.dn,
    });
    return { status: response.status, data: response.data };
  } catch (err) {
    return err;
  }
});

const initialState = {
  data: [],
  loading: false,
  error: null,
  dropDownData: [],
  dropDownError: null,
  dropDownLoading: null,
  totalCount: 0,
  totalPages: 0,
  pageGroupNumber: 1,
  pageGroupSize: 20,
  groupSearch: '',
  groupIsDescending: false,
  groupSortType: '',
  groupSelectedItems: [],
};

const getOuGroupSlice = createSlice({
  name: 'getOuGroupData',
  initialState,
  reducers: {
    clearDropDownData: (state) => {
      state.dropDownData = [];
    },
    setPageGroupNumber: (state, action) => {
      state.pageGroupNumber = action.payload;
    },
    setPageGroupSize: (state, action) => {
      state.pageGroupSize = action.payload;
    },
    setGroupSearch: (state, action) => {
      state.groupSearch = action.payload;
    },
    setGroupIsDescending: (state, action) => {
      state.groupIsDescending = action.payload;
    },
    setGroupSortType: (state, action) => {
      state.groupSortType = action.payload;
    },
    setGroupSelectedItems: (state, action) => {
      state.groupSelectedItems = action.payload;
    },
    resetGroups: (state) => {
      state.pageGroupNumber = 1;
      state.pageGroupSize = 20;
      state.groupSearch = '';
      state.groupIsDescending = false;
      state.groupSortType = '';
    },
  },

  extraReducers: (builder) => {
    builder
      //for Goupdtaa
      .addCase(getOuGroupData.pending, (state) => {
        state.loading = true;
      })
      .addCase(getOuGroupData.fulfilled, (state, action) => {
        state.loading = false;
        state.totalCount = action.payload.totalCount;
        state.totalPages = action.payload.totalPages;
        state.data = action.payload.gropuList;
        state.error = null;
      })
      .addCase(getOuGroupData.rejected, (state, action) => {
        state.loading = false;
        state.data = [];
        state.error = action.error.message;
      })

      .addCase(getDropDownGroupData.fulfilled, (state, action) => {
        state.dropDownLoading = false;
        state.dropDownData = action.payload;
        state.dropDownError = null;
      });
  },
});
export const {
  clearDropDownData,
  setPageGroupNumber,
  setPageGroupSize,
  setGroupSearch,
  setGroupIsDescending,
  setGroupSortType,
  setGroupSelectedItems,
  resetGroups,
} = getOuGroupSlice.actions;
export default getOuGroupSlice.reducer;
